import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = ({ showTitle = true, showPrivacyLink = true, className = '' }) => {
  return (
    <footer className={`relative z-10 py-6 text-center ${className}`}>
      {showTitle && (
        <h3 className="text-white text-xl font-bold">
          AUMENU<span className="text-[#D4AF37]">.CH</span>
        </h3>
      )}
      <a
        href="mailto:info@aumenu.ch"
        className="text-white/60 hover:text-[#D4AF37] text-sm block mt-2 transition-colors"
        data-testid="footer-email"
      >
        info@aumenu.ch
      </a>
      {showPrivacyLink && (
        <Link
          to="/confidentialite"
          className="text-white/40 hover:text-[#D4AF37] text-sm block transition-colors"
          data-testid="footer-privacy-link"
        >
          Politique de confidentialité
        </Link>
      )}
      <p className="text-white/30 text-xs mt-4">
        &copy; {new Date().getFullYear()} AuMenu.ch
      </p>
    </footer>
  );
};
